import React from 'react';
import ButtonsSearch from '../../../../../../components/NovoSistema/ButtonsSearch';
import { ContainerSection } from '../../../../../../components/NovoSistema/ContainerSection';
import InputDate from '../../../../../../components/NovoSistema/InputDate';
import InputText from '../../../../../../components/NovoSistema/InputText';
import SelectAndOptions from '../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../components/NovoSistema/WrapperInputsNewSystem';

export default function AprovacaoPOSearch() {
  return (
    <div>
      <ContainerSection>
        <h3>Pesquisa</h3>
        <WrapperInputsNewSystem>
          <InputDate title="Emissão Inicial" id="EmissaoInicial" widthPercentage="20%" />
          <InputDate title="Emissão Final" id="EmissaoFinal" widthPercentage="20%" />
          <InputDate title="Entrega Inicial" id="EntregaInicial" widthPercentage="20%" />
          <InputDate title="Entrega Final" id="EntregaFinal" widthPercentage="20%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <InputText title="Parceiro de Negócios" id="ParceiroDeNegocios" widthPercentage="47%" />
          <InputText title="Cotação de Compra" id="CotacaoDeCompra" widthPercentage="20%" />
          <InputText title="Pedido de Compra" id="PedidoDeCompra" widthPercentage="20%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <InputText title="Produto" id="Produto" widthPercentage="75%" />
          <SelectAndOptions
            title="Situação"
            id="Situacao"
            optionsArray={[
              '',
              'Todos',
              'Aberta',
              'Enviada',
              'Cancelada',
              'Finalizada Manualmente',
              'Recebido Parcial',
              'Recebido Total',
            ]}
            widthPercentage="20%"
          />
        </WrapperInputsNewSystem>
        <ButtonsSearch />
      </ContainerSection>
    </div>
  );
}
